import { getUserProfileDetails } from "../../../core/api/authAPI";
import useAuthStore from "../../../core/store/authStore";

const useFreshCreditCheck = () => {
  const { setUserProfile } = useAuthStore();

  const checkCredit = async (type) => {
    try {
      const response = await getUserProfileDetails();
      if (response?.success === true && response?.data) {
        setUserProfile(response.data); // Sync latest profile to global store
        
        const profile = response.data;
        const wallet = profile.credit_wallet || {};
        
        if (type === "property") {
          return (wallet.free_post_property || wallet.paid_post_property || 0) > 0;
        } else if (type === "project") {
          return (wallet.free_post_project || wallet.paid_post_project || 0) > 0;
        } else if (type === "featured_property") {
          return (wallet.free_featured_property || wallet.paid_featured_property || 0) > 0;
        } else if (type === "top_developer") {
          return (wallet.free_top_developer || wallet.paid_top_developer || 0) > 0;
        } else if (type === "offer") {
          return (wallet.free_post_offer || wallet.paid_post_offer || 0) > 0;
        }
      }
      return false; // Fail safe
    } catch (error) {
      console.error("Failed to fetch fresh profile for credit check:", error);
      return false;
    }
  };

  return { checkCredit };
};

export default useFreshCreditCheck;
